import {t} from "@lingui/core/macro";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

interface Props {
    isModifyingChild: boolean;
    /**
     * Whether the user has the ability to reauthenticate the account. This can
     * be either a password or a single-sign on method.
     */
    canReauth: boolean;
    primaryEmail?: Nullable<string>;
}

/**
 * Show password requirement message if needed.
 *
 * This message is primarily for parent-managed child accounts. They
 * will have an email but no password and no other way to reauth so
 * must first add a password.

 * Accounts created through Microsoft SSO have no auth email or
 * password and need to be able to add an email. They do not need a
 * password as they can use MS SSO to reauth so we do not show this
 * message.
 */
export const MaybePasswordRequiredMessage: React.FC<Props> = ({
    isModifyingChild,
    canReauth,
    primaryEmail,
}) => {
    if (isModifyingChild || canReauth || !primaryEmail) {
        return null;
    }

    return (
        <>
            <View style={{height: sizing.size_120}} />
            <Body tag="em">
                {t`To connect another email address to your Khan Academy account, first add a password to your account in the "Password" section above.`}
            </Body>
        </>
    );
};
